import React from "react";
import { Route } from "react-router";
import { Navigate, Routes } from "react-router-dom";

import Header from "./Header";
import DBListSELeCT from "./db-list/DBListSELeCT";
import AdminDashboardOffer from "./offer/AdminDashboardOffer";
import UserListContainer from "./user/UserListContainer";
import SideBar from "../../common/management/sidebar/SideBar";
import ManagementPageContainer from "../../common/management/ManagementPageContainer";
import styles from "./ManagementOutline.module.scss";
import SelectReleaseList from "./release/SelectReleaseList";
import TermListContainer from "./taxonomy/TermListContainer";
import OfferListContainer from "./offer/OfferListContainer";
import ProjectListContainer from "../../common/management/project/ProjectListContainer";
import ReleaseProjectListContainer from "./release/ReleaseProjectListContainer";
import ProjectApplicationDetailContainer from "./project/application/ProjectApplicationDetailContainer";
import ApplicationListContainer from "./application/ApplicationListContainer";
import { ReleasePersonPreviewContainer } from "../../common/management/release/ReleasePersonPreviewContainer";
import { ReleaseTeamPreviewContainer } from "../../common/management/release/ReleaseTeamPreviewContainer";
import { ReleaseProjectPreviewContainer } from "../../common/management/release/ReleaseProjectPreviewContainer";
import TaxonomyListContainer from "./taxonomy/TaxonomyListContainer";
import PersonDetailContainer from "./db-list/detail/PersonDetailContainer";
import TeamDetailContainer from "./db-list/detail/TeamDetailContainer";
import UserOverviewContainer from "./user/UserOverviewContainer";
import NewsTOPSliderSettingsContainer from "./news-topslider/NewsTOPSliderSettingsContainer";
import EventListContainer from "./event/EventListContainer";
import { ReleaseEventListContainer } from "./release/ReleaseEventListContainer";
import ReleaseEventPreviewContainer from "../../common/management/release/ReleaseEventPreviewContainer";
import TopicsListContainer from "./topics/TopicsListContainer";
import ReleaseTopicsContainer from "./release/ReleaseTopicsListContainer";
import ReleaseTopicsPreviewContainer from "../../common/management/release/ReleaseTopicsPreviewContainer";
import TopicsDetailContainer from "./db-list/detail/TopicsDetailContainer";
import ProjectDetailContainer from "./db-list/detail/ProjectDetailContainer";
import EventDetailContainer from "./db-list/detail/EventDetailContainer";
import FeaturedProfileSettingsContainer from "./featured-items/profile/FeaturedProfileSettingsContainer";
import FeaturedTeamSettingsContainer from "./featured-items/team/FeaturedTeamSettingsContainer";
import FeaturedGameSettingsContainer from "./featured-items/term/game/FeaturedGameSettingsContainer";
import FacilityListContainer from "./facility/FacilityListContainer";
import FacilityDetailContainer from "./facility/FacilityDetailContainer";
import FacilityCreateContainer from "./facility/FacilityCreateContainer";
import FeaturedFacilitySettingsContainer from "./facility/FeaturedFacilitySettingsContainer";
import FacilityDeletionRequestListContainer from "./facility/FacilityDeletionRequestListContainer";
import ReleaseFacilityListContainer from "./release/ReleaseFacilityListContainer";
import ReleaseFacilityPreviewContainer from "../../common/management/release/ReleaseFacilityPreviewContainer";
import FeaturedProjectSettingsContainer from "./project/FeaturedProjectSettingsContainer";
import GameSelectionListContainer from "./game-selection/GameSelectionListContainer";
import GameSelectionDetailContainer from "./game-selection/GameSelectionDetailContainer";
import { useMetaData } from "../../utils/useMetaData";

const Management: React.FC = () => {
  useMetaData({ title: "管理画面", description: "", imgUrl: "" });

  return (
    <React.Fragment>
      <Header />
      <div className={styles["p-management"]}>
        <SideBar />

        <Routes>
          {/* 会員一覧 */}
          <Route
            path="member"
            element={
              <ManagementPageContainer
                key={"member"}
                apiComponent={UserListContainer}
              />
            }
          />
          <Route
            path="member/:id"
            element={
              <UserOverviewContainer isSelect={true} pageTitle="ユーザー詳細" />
            }
          />

          {/* データベース一覧 */}
          <Route
            path="database"
            element={
              <ManagementPageContainer
                key={"database"}
                apiComponent={DBListSELeCT}
              />
            }
          />
          <Route
            path="database/person/:id"
            element={<PersonDetailContainer />}
          />
          <Route path="database/team/:id" element={<TeamDetailContainer />} />

          <Route
            path="release"
            element={
              <ManagementPageContainer
                key={"release"}
                apiComponent={SelectReleaseList}
              />
            }
          />
          <Route
            path="release/person/:id"
            element={<ReleasePersonPreviewContainer isSelect={true} />}
          />

          <Route
            path="release/team/:id"
            element={<ReleaseTeamPreviewContainer isSelect={true} />}
          />

          {/* オファー */}
          <Route
            path="offer"
            element={
              <ManagementPageContainer
                key={"offer"}
                apiComponent={(props) => (
                  <OfferListContainer isSelect={true} {...props} />
                )}
              />
            }
          />
          <Route
            path="offer/:id"
            element={<AdminDashboardOffer isSelect={true} />}
          />

          {/* プロジェクト */}
          <Route
            path="project"
            element={
              <ManagementPageContainer
                key={"project"}
                apiComponent={(props) => (
                  <ProjectListContainer isSelect={true} {...props} />
                )}
              />
            }
          />

          <Route
            path="project/application"
            element={
              <ManagementPageContainer
                key={"application"}
                apiComponent={(props) => (
                  <ApplicationListContainer isSelect={true} {...props} />
                )}
              />
            }
          />

          <Route
            path="project/application/:id"
            element={<ProjectApplicationDetailContainer isSelect={true} />}
          />

          <Route
            path="project/release"
            element={
              <ManagementPageContainer
                key={"project-release"}
                apiComponent={(props) => (
                  <ReleaseProjectListContainer isSelect={true} {...props} />
                )}
              />
            }
          />

          <Route
            path="project/release/:id"
            element={<ReleaseProjectPreviewContainer isSelect={true} />}
          />

          <Route
            path="project/:id"
            element={<ProjectDetailContainer isSelect={true} />}
          />

          {/* イベント */}
          <Route
            path="event"
            element={
              <ManagementPageContainer
                key={"event"}
                apiComponent={(props) => (
                  <EventListContainer isSelect={true} {...props} />
                )}
              />
            }
          />

          <Route
            path="event/release"
            element={
              <ManagementPageContainer
                key={"event-release"}
                apiComponent={(props) => (
                  <ReleaseEventListContainer isSelect={true} {...props} />
                )}
              />
            }
          />

          <Route
            path="event/release/:id"
            element={<ReleaseEventPreviewContainer isSelect={true} />}
          />

          <Route
            path="event/:id"
            element={<EventDetailContainer isSelect={true} />}
          />

          {/* トピックス */}
          <Route
            path="topics"
            element={
              <ManagementPageContainer
                key={"topics"}
                apiComponent={(props) => <TopicsListContainer {...props} />}
              />
            }
          />

          <Route
            path="topics/release"
            element={
              <ManagementPageContainer
                key={"topics-release"}
                apiComponent={(props) => <ReleaseTopicsContainer {...props} />}
              />
            }
          />

          <Route
            path="topics/release/:id"
            element={<ReleaseTopicsPreviewContainer />}
          />

          <Route path={`topics/:id`} element={<TopicsDetailContainer />} />

          <Route path="/facility">
            <Route
              index
              element={
                <ManagementPageContainer
                  key="facility"
                  apiComponent={(props) => <FacilityListContainer {...props} />}
                />
              }
            />
            <Route path=":id" element={<FacilityDetailContainer />} />
            <Route path="create" element={<FacilityCreateContainer />} />
            <Route
              path="featured"
              element={<FeaturedFacilitySettingsContainer />}
            />
            <Route
              path="delete"
              element={
                <ManagementPageContainer
                  key="facilityDeletion"
                  apiComponent={(props) => (
                    <FacilityDeletionRequestListContainer {...props} />
                  )}
                />
              }
            />
            <Route
              path="release"
              element={
                <ManagementPageContainer
                  key={"facility-release"}
                  apiComponent={(props) => (
                    <ReleaseFacilityListContainer {...props} />
                  )}
                />
              }
            />
            <Route
              path="release/:id"
              element={<ReleaseFacilityPreviewContainer />}
            />
          </Route>

          {/* タクソノミー */}
          <Route
            path="taxonomy"
            element={
              <ManagementPageContainer
                key={"taxonomy"}
                apiComponent={TaxonomyListContainer}
              />
            }
          />

          <Route
            path="taxonomy/:id"
            element={
              <ManagementPageContainer
                key={"term"}
                apiComponent={TermListContainer}
              />
            }
          />

          {/* 注目設定 */}
          <Route
            path="featured/profile"
            element={<FeaturedProfileSettingsContainer />}
          />
          <Route
            path="featured/team"
            element={<FeaturedTeamSettingsContainer />}
          />
          <Route
            path="featured/project"
            element={<FeaturedProjectSettingsContainer />}
          />
          <Route
            path="featured/game"
            element={<FeaturedGameSettingsContainer />}
          />

          {/* TOPスライダー */}
          <Route path="news" element={<NewsTOPSliderSettingsContainer />} />

          {/* ゲーム項目設定 */}
          <Route
            path="game-selection"
            element={<GameSelectionListContainer />}
          />

          <Route
            path="game-selection/:id"
            element={<GameSelectionDetailContainer />}
          />

          <Route path="*" element={<Navigate to="database" replace />} />
        </Routes>
      </div>
    </React.Fragment>
  );
};

export default Management;
